import { Form } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import tw from 'twin.macro';

interface ErrorMsgProps {
  name: string;
  msg: string;
}
const ErrorMsg = ({ name, msg }: ErrorMsgProps) => {
  const form = useFormInstance();

  return (
    <>
      <Form.Item
        name={name}
        rules={[
          {
            validator: (_, value) =>
              value ? Promise.resolve() : Promise.reject(msg),
          },
        ]}
        hidden
      />

      <Form.Item shouldUpdate noStyle>
        {() => {
          const errors = form.getFieldError(name);

          return (
            <Form.ErrorList
              errors={errors}
              help={
                errors.length > 0 ? (
                  <div
                    css={tw`text-[#ff4d4f] text-[14px] leading-[1.5715] mt-[4px]`}
                  >
                    {errors[0]}
                  </div>
                ) : null
              }
            />
          );
        }}
      </Form.Item>
    </>
  );
};

export default ErrorMsg;
